<template>
  <div>
    <Mapa class="mapa" ref="refmapa" id="mapa"></Mapa>
    <NavResponsive ref="refmenu" v-if="dispositivo == false"/>
    <Legend ref="leyenda" class="componente-leyenda" v-if="dispositivo == false"></Legend>
    <MapStyleControl v-if="dispositivo == false"/>
    <Spinner size="large" line-fg-color="green" line-bg-color="#FFFFFF" class="spinner" v-if="showLoading" ref="refspinner"></Spinner>
    <DialogDisclaimer v-show="showModalDisclaimer" @close="showModalDisclaimer = false" class="dialog-disclaimer"/>
  </div>
</template>
<script>

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(device);

import Vue from 'vue';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import device from "vue-device-detector"
import * as LocalStorage from '@/helpers/localstorage';
import Mapa from "@/components/main/Mapa";
import NavResponsive from "@/components/main/web/menu/NavResponsive";
import Legend from "@/components/main/web/legend/Legend";
import MapStyleControl from "@/components/main/web/map/MapStyleControl";
import Spinner from 'vue-simple-spinner';
import DialogDisclaimer from '@/components/main/dialog/DialogDisclaimer';

export default {
  name: "App",
  data() {
    return {
      showModalDisclaimer: false,
      showLoading: false,
      dispositivo: null,
    }
  },
  components: {
    Mapa,
    Legend,
    Spinner,
    NavResponsive,
    MapStyleControl,
    DialogDisclaimer,
  },
  methods: {
    setShowLoading(show) {
      this.showLoading = show;
    },
  },
  mounted() {
    this.dispositivo = this.$device.ios;

    if (this.$device.ios === true) {
      this.dispositivo = true;
    } else if (this.$device.android === true) {
      this.dispositivo = true;
    } else {
      this.dispositivo = false;
    }

    // if (!LocalStorage.getDisclaimer()) {
    //   this.showModalDisclaimer = true;
    // }
    this.showModalDisclaimer = true;
  },
  created() {
    this.$root.$on('app-show-loading', this.setShowLoading);
  },
  beforeDestroy() {
    this.$root.$off('app-show-loading', this.setShowLoading);
  }
};

</script>
<style lang="scss">
@import "../../scss/App";

html, body {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
}

figure {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 10px;
  margin-inline-end: 0;
}

#app {
  font-family: 'Open Sans', sans-serif;
}

.mapa {
  height: 100%;
  width: 100%;
  position: absolute;
  font-family: 'Open Sans', sans-serif;
}

.spinner {
  z-index: 5000 !important;
  background: #000;
  opacity: 0.5;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  top: 0;
}

.componente-leyenda {
  z-index: 10000;
}

.dialog-disclaimer {
  z-index: 10001;
}

</style>
